import httpClient from "../../../api/httpClient";
import Cookies from "js-cookie";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthToken = () => Cookies.get("authToken");

const getOfficeCodes = () => {
    const raw = Cookies.get("officeCodes");
    if (!raw) return "";
    return raw
        .split(",")
        .filter(Boolean)
        .map(code => `officeCodes=${encodeURIComponent(code)}`)
        .join("&");
};


export const getCurrentOrgInfo = () => {
    const orgDataRaw = localStorage.getItem("organizationData");
    if (!orgDataRaw) return {orgId: null, officeCode: null};
    try {
        const orgData = JSON.parse(orgDataRaw);
        // If orgData is an array, get the first item
        const firstOrg = Array.isArray(orgData) ? orgData[0] : orgData;
        return {
            orgId: firstOrg.orgId || null,
            officeCode: firstOrg.officeCode || null,
        };
    } catch {
        return {orgId: null, officeCode: null};
    }
};

export const fetchTeamMembers = async (officeCode, token) => {
    const officeCodesRaw = Cookies.get("officeCodes");
    const params = officeCodesRaw
        ? officeCodesRaw.split(",").filter(Boolean).map(code => `officeCodes=${encodeURIComponent(code)}`).join("&")
        : "";

    return httpClient.get(`/api/organizations/users/by-office-codes?${params}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
}

export const blockUser = async (email, token) =>
    httpClient.post(`/auth/user/blockUser?email=${email}`, {}, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
export const unBlockUser = async (email, token) =>
    httpClient.post(`/auth/user/unBlockUser?email=${email}`, {}, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });

export const viewUserProfile = async (email) => {
    const token = Cookies.get("authToken");
    return httpClient.get(`/auth/user/viewprofile`, {
        params: {userEmail: email},
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};

export const getUserPreferences = async () => {
    const token = getAuthToken();
    return httpClient.get(`/api/notifications/user_preferences/user`, {  
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};

export const updateUserPreferences = async (category, isEnabled) => {
    const token = getAuthToken();
    return httpClient.patch(`/api/notifications/user_preferences/user/set_enabled`, {}, {
        params: {
            enabled: isEnabled,
            category: category
        },
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};

export const viewOrganizationById = async (orgId) => {
    const token = getAuthToken();
    return httpClient.get(`/api/organizations/${orgId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};

export const viewOrganizationByOfficeCode = async (officeCode) => {
    const token = getAuthToken();
    return httpClient.get(`/api/organizations/by-office-code/${encodeURIComponent(officeCode)}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};


//  Search Users with Filters
// ======================================================
export const searchUsers = async (filters = {}, page = 0, size = 10) => {
    const token = Cookies.get("authToken");

    const params = {
        searchTerm: filters.searchTerm || "",
        officeCodes:
            filters.offices?.length > 0
                ? filters.offices
                : (Cookies.get("officeCodes")
                    ? Cookies.get("officeCodes").split(",").filter(Boolean)
                    : []),

        roleIds:
            filters.roles?.length > 0
                ? filters.roles.map((r) => (typeof r === "object" ? r.id : r))
                : [],
        status: filters.status || "",
        sortBy:
            filters.sortBy === "Name (A–Z)"
                ? ["firstName"]
                : filters.sortBy === "Recently Added"
                    ? ["createdAt,desc"]
                    : [],
        page,
        size,
    };

    const paramsSerializer = {
        serialize: (params) => {
            const query = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((v) => query.append(key, v)); // ✅ repeated param
                } else if (value !== undefined && value !== "") {
                    query.append(key, value);
                }
            });
            return query.toString();
        },
    };

    return httpClient.get(`/auth/user/search`, {
        params,
        paramsSerializer, // ✅ important!
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};


// Search Organizations (Preferred Partners)
export const searchOrganizations = async (searchTerm, page = 0, size = 10) => {
    const token = Cookies.get("authToken");
    return httpClient.get(`/api/organizations/search`, {
        params: {searchTerm, page, size},
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};

// export const 


// http://localhost:8080/api/onboarding/add-users?officeCode=ASCENDCARGO
export const fetchPendingInvites = async (officeCode) =>
    httpClient.get(`/api/onboarding/pending-invites?officeCode=${officeCode}`);

export const resendInvite = async (officeCode, email) =>
    httpClient.post(`/api/onboarding/resend-invite?officeCode=${officeCode}`, {email});

export const uploadBulkUsers = async (officeCode, users) =>
    httpClient.post(`/api/onboarding/add-users?officeCode=${officeCode}`,
        users,
        {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
                "Content-Type": "application/json",
            },
        }
    );

export const createOrgInvite = async (officeCode, inviteType, validity, email, scacCode) =>
    httpClient.post(
        `/api/invites/create`,
        {}, {
            headers: {Authorization: `Bearer ${localStorage.getItem("authToken") || Cookies.get("authToken")}`},
            params: {
                originalOfficeCode: officeCode,
                inviteType,
                validUntilDate: validity,
                recipientEmail: email,
                scacCode: scacCode,
            },
        }
    );

export const fetchOrgInvites = async (officeCode) =>

    httpClient.get(`/api/invites/list?${getOfficeCodes()}`,
        {
            headers: {
                Authorization: `Bearer ${Cookies.get("authToken")}`
            }
        }
    );
export const cancelOrgInvite = async (row) =>
    httpClient.post(
        `/api/invites/cancel?inviteCode=${row.uuid}`,
        {},
        {
            headers: {Authorization: `Bearer ${getAuthToken()}`}
        }
    );


//pref Partners apis


export const fetchPreferredPartners = (officeCode) =>
    httpClient.get(`/api/pref-partners/${officeCode}`, {
        headers: {Authorization: `Bearer ${getAuthToken()}`},
    });

export const addPreferredPartner = (officeCode, partnerCode) =>
    httpClient.post(
        `/api/pref-partners/${officeCode}`,
        [partnerCode],
        {headers: {"Content-Type": "application/json"}}
    );

export const deletePreferredPartner = (officeCode, partnerCode) =>
    httpClient.delete(`/api/pref-partners/${officeCode}/${partnerCode}`);


//  Child Organization Related API's
export const fetchChildOrganizations = async (parentId) =>
    httpClient.get(`/api/organizations/getchildorg/${parentId}`, {
        headers: {Authorization: `Bearer ${getAuthToken()}`},
    });

export const addChildOrganization = async (officeCode, data) =>
    httpClient.post(
        `/api/organizations/child/${officeCode}`,
        data,
        {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
                "Content-Type": "application/json",
            },
        }
    );

export const deleteOffice = async (orgId) =>
    httpClient.delete(`/api/organizations/${orgId}`, {
        headers: { Authorization: `Bearer ${getAuthToken()}` },
    });

export const deleteWarehouse = async (locationId) =>
    httpClient.delete(`/api/locations/delete/${locationId}`, {
        headers: { Authorization: `Bearer ${getAuthToken()}` },
    });
export const checkOfficeCode = async (officeCode) =>
    httpClient.post(
        `/api/onboarding/check-office-code?officeCode=${officeCode}`,
        {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
                "Content-Type": "application/json",
            }
        }
    );


// Role APIs
// Previously looped once per the viewer's own organizationTypes, searching /api/role/search by
// org-type keyword each time -- that endpoint does a fuzzy substring match against roleName/
// roleDescription (built for onboarding's "find the one role matching this invite type" use case,
// not a general listing), so any role whose name/description didn't happen to contain "shipper"/
// "carrier"/"agent" (e.g. "Yard Hostler") could never appear here for ANY org type. A single
// no-keyword call returns every active role -- the backend query already treats a null keyword as
// "match everything" (RoleRepository.searchRoles).
export const fetchAllRoles = async (token) =>
    httpClient.get(`/api/role/search`, {
        params: {active: true},
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });


export const updateUserRole = async (userEmail, roleId, checked, token) => {
    const url = `/auth/user/${userEmail}/roles/${roleId}`;
    if (checked) {
        return httpClient.post(url, {}, {
            headers: {Authorization: `Bearer ${token}`}
        });
    } else {
        return httpClient.delete(url, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
};

// Office APIs
export const fetchAllOffices = async (token) =>
    httpClient.get(`/auth/user/getOrganizations`, {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "application/json",
        },
    });
export const fetchChildOffices = async (parentOfficeCode, token) =>
    httpClient.get(`/api/organizations/getchildorg/${parentOfficeCode}`, {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "application/json",
        },
    });

// LGX-1142: remove-user takes userId (a Long), not userEmail -- add-user's endpoint takes
// userEmail. This previously always sent userEmail for both, so unchecking an office (removing
// it) 400'd on the backend's missing required `userId` param every time, silently (the caller
// had no .catch to surface it). userId is the row's own numeric id, same field TeamTable's own
// "Remove Member" action already uses for this same endpoint.
export const updateUserOffice = async (userEmail, officeCode, checked, token, userId) => {
    const endpoint = checked ? "add-user" : "remove-user";
    const identifierParam = checked
        ? `userEmail=${encodeURIComponent(userEmail)}`
        : `userId=${userId}`;
    const url = `/api/organizations/${endpoint}?officeCode=${officeCode}&${identifierParam}`;
    return httpClient.post(url, {}, {
        headers: {Authorization: `Bearer ${getAuthToken()}`}
    });
};


//location management
export const addChildLocation = async (parentRef, token, officeCode, data) =>
    httpClient.post(`/api/locations/addChildLocation/${parentRef}`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
            Accept: "application/json",
        },
    });

export const createLocation = async (token, officeCode, data) =>
    httpClient.post(`/api/locations/add`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
            Accept: "application/json",
        },
    });

// geography typeahead — backed by the shared GlobalCities/Country reference data
export const searchCountries = async (name) =>
    httpClient.get(`/api/search/countries`, {
        params: { name },
        headers: { Authorization: `Bearer ${getAuthToken()}` },
    });

export const searchStatesByCountry = async (countryCode, stateName) =>
    httpClient.get(`/api/search/states/by-country`, {
        params: { countryCode, stateName },
        headers: { Authorization: `Bearer ${getAuthToken()}` },
    });

export const searchCitiesByCountryState = async (countryCode, stateCode, cityName) =>
    httpClient.get(`/api/search/cities/by-country-state`, {
        params: { countryCode, stateCode, cityName },
        headers: { Authorization: `Bearer ${getAuthToken()}` },
    });

export const saveNewCity = async (countryCode, stateCode, cityName) =>
    httpClient.post(`/api/search/cities/save-new`, null, {
        params: { countryCode, stateCode, cityName },
        headers: { Authorization: `Bearer ${getAuthToken()}` },
    });

export const fetchEventsByCalendarRef = async (calendarRefId) => {
    const res = await httpClient.get(
        `/api/events/by-cal-ref/${calendarRefId}`,
        {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
                Accept: "application/json",
            },
        }
    );
    return res.data;
};


export const fetchLocation = async (officeCode, token) =>
    httpClient.get(`/api/locations/by-office-code/${officeCode}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });

export const fetchLocationsByOfficeCodes = async () => {
    return httpClient.get(`/api/locations/by-office-codes?${getOfficeCodes()}`, {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "*/*"
        }
    });
};


export const fetchLocationsByGrouped = async () => {
    // Scoped to the user's SINGLE currently-active office would only ever show that one
    // office's own locations — send the full accessible-offices list instead, same as every
    // other multi-office fetch (fetchLocationsByOfficeCodes, fetchChildOrganizations, etc.),
    // so a Diamond user sees locations across all of Diamond's offices, not just whichever one
    // happens to be "active" right now.
    const officeCodes = (Cookies.get("officeCodes") || Cookies.get("officeCode") || "")
        .split(",")
        .filter(Boolean);
    return httpClient.get(`/api/locations/grouped`, {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "*/*",
            "Office-Code": officeCodes.join(","),
        },
    });
};

export const fetchChildrenByLocationRef = async (locationRef) => {
    const token = Cookies.get("authToken");
    if (!locationRef || !token) throw new Error("Missing locationRef or authToken");

    return httpClient.get(`/api/locations/children/by-ref?locationRef=${encodeURIComponent(locationRef)}`, {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "*/*"
        }
    });
};
// Fetch locations, then fetch children using the first location's locationRef
export const fetchLocationsAndChildren = async (officeCode, token) => {
    try {
        const res = await fetchLocation(officeCode, token);
        const locations = res.data;
        if (locations && locations.length > 0 && locations[0].locationRef) {
            const locationRef = locations[0].locationRef;
            const childrenRes = await httpClient.get(
                `/api/locations/children/by-ref?locationRef=${locationRef}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );
            return {
                locations,
                children: childrenRes.data,
            };
        } else {
            return {locations, children: []};
        }
    } catch (error) {
        // Handle error as needed
        return {locations: [], children: []};
    }
};